module.exports = __webpack_public_path__ + "img/09_Elbphilharmonie_iPad_P.03e715df.jpg";